<template>
  <!--    仅为android测试下载用-->
</template>

<script>
  import { getAndroidUrl } from '../api/appManageApi'
  import { handleResponse } from '../utils/response'

  export default {
    name: 'testForAndroid',
    mounted () {
      getAndroidUrl().then(response => {
        handleResponse(response, data => {
          window.location.href = data.url

        }, error => {

        })
      })
    }
  }
</script>

<style scoped>

</style>
